import { gql } from "@apollo/client";
import { messageHeaders } from "features/common/fragments";
import Fragments from "./fragments";

export const CLIENT_SAVED = gql`
  subscription clientSaved($documentId: Int!) {
    clientSaved(documentId: $documentId) {
      documentId
      partner {
        ...partnerData
      }
      silentMode
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
  ${Fragments.partnerData}
`;

export const INSURED_SAVED = gql`
  subscription insuredSaved($documentId: Int!) {
    insuredSaved(documentId: $documentId) {
      documentId
      partner {
        ...partnerData
      }
      silentMode
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
  ${Fragments.partnerData}
`;

export const PARTNERS_UPDATED = gql`
  subscription partnersUpdated {
    partnersUpdated {
      partners {
        ...partnerData
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
  ${Fragments.partnerData}
`;
